import { useParams } from 'react-router-dom';
import { useAppSelector } from '@store';
import { ButtonPrimary, ButtonPseudo, SidePanel, SidePanelType } from '@ui/src';
import { OrganizationType } from '../../types';
import useCreateDocument from '../hooks/use-create-document';
import CreateDocumentForm from '../../../../components/common/documents/create';

const CreateDocument = ({
  customerType,
}: {
  customerType: OrganizationType;
}) => {
  const { allowedCategories } = useAppSelector(
    (state) => state.customerDocuments,
  );
  const { customerId } = useParams();

  const {
    panelIsOpen,
    handleClose,
    documentSubmitInProgress,
    uploadedFiles,
    onSubmitDocuments,
    onUpload,
    setSelectedGroup,
    checkDocumentStringNameInProgress,
    fileUploadInProgress,
    uploadInputRef,
    dropZoneInputRef,
    onDelete,
    uploadedFilesErrors,
    selectedGroup,
    setExpirationDate,
    expirationDate,
    setUploadedFiles,
    attachedDocumentsErrors,
    attachedFiles,
    uploadedDocumentsErrors,
  } = useCreateDocument({
    customerType,
    allowedCategories,
    customerId,
  });

  return (
    <SidePanel
      type={SidePanelType.Accounts}
      closeOnClickOutside
      isOpen={panelIsOpen}
      onClose={handleClose}
      title="Add document"
      sidepanelExpandedKey="customer-create-document"
      footer={
        <>
          <ButtonPrimary
            text={documentSubmitInProgress ? 'Loading...' : 'Add document'}
            disabled={!uploadedFiles.length || documentSubmitInProgress}
            onClick={onSubmitDocuments}
            bold
          />
          <ButtonPseudo text="Close" onClick={handleClose} bold />
        </>
      }
    >
      <CreateDocumentForm
        onUpload={onUpload}
        onSelect={setSelectedGroup}
        fileUploadInProgress={
          checkDocumentStringNameInProgress || fileUploadInProgress
        }
        uploadInputRef={uploadInputRef}
        dropZoneInputRef={dropZoneInputRef}
        onDelete={onDelete}
        uploadedFiles={uploadedFiles}
        uploadedFilesErrors={uploadedFilesErrors}
        selectedGroup={selectedGroup}
        setExpirationDate={setExpirationDate}
        expirationDate={expirationDate}
        allowedCategories={allowedCategories}
        setUploadedFiles={setUploadedFiles}
        attachedDocumentsErrors={attachedDocumentsErrors}
        attachedFiles={attachedFiles}
        uploadedDocumentsErrors={uploadedDocumentsErrors}
      />
    </SidePanel>
  );
};

export default CreateDocument;
